import { getDataMapper, mapField, formatISODuration } from "@/shared";

// Добавляем хелпер для безопасной конвертации
const convertToNumber = (value) => {
    const num = Number(value);

    return isNaN(num) ? 0 : num;
};

// Функция для обработки объектов с duration
const mapDuration = (duration) => {
    if (!duration) return null;

    return formatISODuration({
        days: convertToNumber(duration.days),
        hours: convertToNumber(duration.hours),
        minutes: convertToNumber(duration.minutes),
    });
};

// Функция для обработки moreThen
const mapMoreThen = (moreThen) => {
    if (!moreThen) return null;

    return formatISODuration({
        days: convertToNumber(moreThen.days),
        hours: convertToNumber(moreThen.hours),
        minutes: 0, // если нужно учитывать минуты, добавьте конвертацию
    });
};

export const mapInventoryPriceToServer = getDataMapper(
    {
        id: mapField("id", Number),
        title: mapField("title"),
        values: mapField("values", {
            id: mapField("id", Number),
            price_id: mapField("priceId", Number),
            period: mapField("period", mapDuration),
            value: mapField("value", (v) => convertToNumber(v)),
            more_then: mapField("moreThen", mapMoreThen),
            is_fixed: mapField("isFixed", Boolean),
        }),
    },
    {
        shouldAvoidUndefined: true,
    }
);
